import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/useLanguage";
import { conversionCopy } from "@/lib/conversionCopy";

const MobileContactBar = () => {
  const { language } = useLanguage();
  return (
    <aside aria-label={conversionCopy[language].callback} className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)] gap-2 border-t border-border bg-card p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-lg md:hidden">
      <Button asChild className="min-h-12 h-auto px-2 py-3 text-sm whitespace-normal leading-snug">
        <Link to="/get-quote"><Phone />{conversionCopy[language].callback}</Link>
      </Button>
      <Button asChild className="min-h-12 h-auto px-2 py-3 bg-accent text-accent-foreground hover:bg-accent/90">
        <a href="https://wa.me/66821858187" target="_blank" rel="noopener noreferrer"><MessageCircle />WhatsApp</a>
      </Button>
    </aside>
  );
};
export default MobileContactBar;